export default "/react/logoSalesFinder-70fb64c8.png";